<div>
	<form [formGroup]="form" nz-form>
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Title</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="title" placeholder="Enter title" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Mode</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<nz-select formControlName="mode" nzPlaceHolder="Select mode">
					<nz-option *ngFor="let item of options" [nzValue]="item.value" [nzLabel]="item.label"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Filter Operator</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<nz-select formControlName="filterOperator" nzPlaceHolder="Select Filter">
					<nz-option [nzValue]="undefined" nzLabel="None"></nz-option>
					<nz-option [nzValue]="'Equals'" [nzLabel]="'Equals'"></nz-option>
					<nz-option [nzValue]="'NotEquals'" [nzLabel]="'Not Equals'"></nz-option>
					<nz-option [nzValue]="'GreaterThan'" [nzLabel]="'Greater Than'"></nz-option>
					<nz-option [nzValue]="'LessThan'" [nzLabel]="'Less Than'"></nz-option>
					<nz-option [nzValue]="'GreaterThanOrEqual'" [nzLabel]="'Greater Than Or Equal'"></nz-option>
					<nz-option [nzValue]="'LessThanOrEqual'" [nzLabel]="'Less Than Or Equal'"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Filter Value</nz-form-label>
			<nz-form-control [nzSpan]="18">
				<input nz-input formControlName="filterValue" placeholder="Filter Value" />
			</nz-form-control>
		</nz-form-item>
		<button nz-button (click)="handleCancel()">Cancel</button>
		<button nz-button class="ms-2" nzType="primary" (click)="handleSave()">Save</button>
		<button nz-button class="float-end" nzType="default" [nzDanger] (click)="handleDelete()">Delete</button>
	</form>
</div>

